import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inactive-dormand-grid',
  templateUrl: './inactive-dormand-grid.component.html',
  styleUrls: ['./inactive-dormand-grid.component.css']
})
export class InactiveDormandGridComponent implements OnInit {
  title="Inactive Dormand List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/inactive-dormand-grid/inactive-dormand-grid.component.ts